export const ticketCreateCommand = 'ticket:create';
export const ticketList = 'ticket:list';
export const ticketSystemBetSettings = 'ticket:systembet:settings';
